/**
 * Core game constants
 */
// Arena
export const ARENA_WIDTH = 1920;
export const ARENA_HEIGHT = 1080;
// Match
export const MATCH_DURATION_SECONDS = 180; // 3 minutes
export const MAX_PLAYERS = 5;
export const MIN_PLAYERS_TO_START = 2;
// Ship physics
export const SHIP_RADIUS = 20;
export const SHIP_THRUST_FORCE = 800;
export const SHIP_MAX_SPEED = 400;
export const SHIP_DRAG = 0.98; // Multiplied per second
export const SHIP_ROTATION_SPEED = 5; // Radians per second
export const SHIP_TAIL_DRAG_PENALTY = 0.02; // Extra drag per tail segment
export const SHIP_TAIL_ROTATION_PENALTY = 0.08; // Rotation slowdown per segment
// Ship health and damage
export const SHIP_MAX_HP = 3; // Ship survives 3 hits, dies on 4th
export const SHIP_INVULNERABLE_TIME = 0.5; // Seconds of invulnerability after hit
export const SHIP_RESPAWN_TIME = 2; // Seconds until respawn after death
export const SHIP_DAMAGE_EXPANSION = 0.15; // Vertex expansion per damage level (15%)
// Projectiles
export const PROJECTILE_SPEED = 800;
export const PROJECTILE_RADIUS = 3;
export const PROJECTILE_LIFETIME = 1.5; // Seconds
export const PROJECTILE_DAMAGE = 1;
export const FIRE_RATE = 5; // Shots per second
export const FIRE_COOLDOWN = 1 / FIRE_RATE;
// Asteroids
export const ASTEROID_SMALL_RADIUS = 20;
export const ASTEROID_MEDIUM_RADIUS = 35;
export const ASTEROID_LARGE_RADIUS = 55;
export const ASTEROID_SMALL_HP = 1;
export const ASTEROID_MEDIUM_HP = 3;
export const ASTEROID_LARGE_HP = 5;
export const ASTEROID_MAX_SPEED = 50;
export const ASTEROID_SPIN_SPEED = 1; // Max radians per second
export const ASTEROID_SPAWN_COUNT = 15; // Initial asteroids
export const ASTEROID_RESPAWN_DELAY = 3; // Seconds
// Crates
export const CRATE_SIZE = 12;
export const CRATE_MAX_SPEED = 80;
export const CRATE_DRAG = 0.95;
export const CRATE_SCATTER_SPEED = 150; // When knocked off
export const CRATE_PICKUP_COOLDOWN = 0.3; // Seconds before can be picked up again
export const CRATES_FROM_SMALL = 1;
export const CRATES_FROM_MEDIUM = 3;
export const CRATES_FROM_LARGE = 6;
// Tail
export const TAIL_SEGMENT_SPACING = 18;
export const TAIL_MAX_LENGTH = 50;
// Station
export const STATION_RADIUS = 40;
export const STATION_TURN_IN_RADIUS = 60;
export const STATION_MOVE_SPEED = 30;
export const STATION_WAYPOINT_MARGIN = 100;
export const STATION_WAYPOINT_CHANGE_TIME = 8; // Seconds between waypoints
// Scoring (points - converted to $ at match end via proportional distribution)
// Final payout = (yourScore / totalScore) × prizePool
export const POINTS_ASTEROID_DESTROYED = 0; // No points for just hitting asteroids
export const POINTS_ORE_TURNED_IN = 1; // 1 point per crate turned in
export const POINTS_PLAYER_DESTROYED = 5; // 5 points for killing another player
export const BONUS_TURN_IN_THRESHOLD = 5; // Minimum crates for bonus
export const BONUS_TURN_IN_MULTIPLIER = 10; // 10 extra points per crate when turning in 5+
// Network
export const TICK_RATE = 60;
export const TICK_MS = 1000 / TICK_RATE;
export const FIXED_DT = 1 / TICK_RATE;
export const NETWORK_SEND_RATE = 20; // State snapshots per second
export const NETWORK_SEND_INTERVAL = Math.floor(TICK_RATE / NETWORK_SEND_RATE);
// Visual
export const GRID_SIZE = 50;
export const GRID_COLOR = '#0a2030';
export const BACKGROUND_COLOR = '#000008';
// NPC AI
export const NPC_COUNT = 4; // 5 players total (1 human + 4 NPCs by default)
export const NPC_DECISION_INTERVAL = 0.3; // Seconds between AI decisions
export const NPC_TURN_IN_THRESHOLD = 5; // Crates before seeking station
export const NPC_FLEE_HEALTH_THRESHOLD = 3; // HP to trigger flee
export const NPC_ATTACK_RANGE = 300;
export const NPC_MINING_RANGE = 400;
export const NPC_COLLECT_RANGE = 200;
export const NPC_ACCURACY_BASE = 0.7; // Base aim accuracy (0-1)
export const NPC_REACTION_TIME = 0.15; // Seconds of input delay
//# sourceMappingURL=game.js.map